export const GET_POST_HISTORY = "GET_POST_HISTORY";